import React from "react";

const HeaderComponent = () => {
  return (
    <div className="container">
      <div className="header row">
        <div className="logo col-md-6">
          {/* <a href="#"> */}
          <img
            alt="amcrestlogo"
            src={`${process.env.PUBLIC_URL}/logo.svg`}
            height="44px"
          />
          {/* </a> */}
        </div>
        <div className="label col-md-6">
          <strong style={{ color: "#ffb400" }}>GPS</strong> Activation
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
